var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gameArea",staticClass:"gameArea",style:(_vm.gameAreaStyle)},[_c('PuzzleGrid',{ref:"puzzleGrid",class:{ "center": _vm.verticalLayout }}),(!_vm.verticalLayout)?_c('WordList',{ref:"wordList",class:{
    "wordList--horizontal": !_vm.verticalLayout,
    "wordList--vertical": _vm.verticalLayout,
  }}):_vm._e(),(_vm.verticalLayout)?_c('WordListMobile',{staticClass:"center wordList--vertical"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }